define('plugin/client-login/model/ClientValidateLoginModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Client sign in model
     *
     * @class ClientModel
     */
    return BaseModel.extend({

        url: '/ext/client/validate-login/',

        defaults: {
            id: null,
            is_logged_in: false
        }

    });

});
